import { Link } from "react-router-dom";
import { getTableFormattedDate } from "../../helpers/date-time-helper";

export const GET_COLUMNS = [
    {
        header: "Quote Id",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => (
            <Link to={`${cellProps.row.original.id}`}>
                {cellProps.row.original.id}
            </Link>
        ),
    },
    {
        header: 'Date Created',
        accessorKey: 'dateCreated',
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps) => getTableFormattedDate(cellProps.row.original.dateCreated),
    },
    {
        header: 'Contact Name',
        accessorKey: 'contactName',
        enableColumnFilter: false,
        enableSorting: true,
    },
    {
        header: 'Contact Phone #',
        accessorKey: 'contactPhone',
        enableColumnFilter: false,
        enableSorting: false,
    },
    {
        header: 'Status',
        accessorKey: 'status',
        enableColumnFilter: false,
        enableSorting: true,
    },
    {
        header: 'Job',
        accessorKey: 'job',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps) => (
            <>
                {cellProps.row.original.job?.name}
            </>
        )
    },
];
